import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { useCallback, useEffect } from 'react';
import { create } from 'zustand';
import { getFromLocalStorage, saveToLocalStorage, } from '../utilities/localStorage';
export var SUSPEND_ON_CLOSE_KEY = 'ShouldKeepRunningWhenClosed';
var useSuspendOnCloseEnabledState = create(function (set) { return ({
    shouldSuspendOnClose: undefined,
    setshouldSuspendOnClose: function (value) {
        set({ shouldSuspendOnClose: value });
    },
}); });
export var useShouldRunAppInBackground = function () {
    var _a, _b;
    var featureGates = useFeatureGates().data;
    var officeComponentContext = useOfficeComponentContext().data;
    var workload = officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload;
    var _c = useSuspendOnCloseEnabledState(), shouldSuspendOnClose = _c.shouldSuspendOnClose, setshouldSuspendOnClose = _c.setshouldSuspendOnClose;
    var suspendOnCloseEnabled = !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result.hwaSuspendGates) === null || _a === void 0 ? void 0 : _a.hwaSuspendOnCloseEnabled) &&
        workload === OfficeWorkload.Hwa &&
        ((_b = window.capabilities) === null || _b === void 0 ? void 0 : _b.includes('suspendOnClose'));
    var hwaSuspendOnCloseAction = useCallback(function (isChecked) {
        setshouldSuspendOnClose(isChecked);
        saveToLocalStorage(SUSPEND_ON_CLOSE_KEY, isChecked);
    }, [setshouldSuspendOnClose]);
    useEffect(function () {
        if (featureGates) {
            getFromLocalStorage(SUSPEND_ON_CLOSE_KEY)
                .then(function (value) {
                if (value === null || value === undefined) {
                    setshouldSuspendOnClose(suspendOnCloseEnabled);
                    if (suspendOnCloseEnabled === true) {
                        saveToLocalStorage(SUSPEND_ON_CLOSE_KEY, true);
                    }
                }
                else {
                    setshouldSuspendOnClose(suspendOnCloseEnabled && value);
                    if (suspendOnCloseEnabled !== true)
                        saveToLocalStorage(SUSPEND_ON_CLOSE_KEY, null);
                }
            })
                .catch(function () {
                setshouldSuspendOnClose(suspendOnCloseEnabled);
                if (suspendOnCloseEnabled === true)
                    saveToLocalStorage(SUSPEND_ON_CLOSE_KEY, true);
            });
        }
    }, [suspendOnCloseEnabled, setshouldSuspendOnClose, featureGates]);
    useEffect(function () {
        window.hwaSuspendOnCloseEnabled = suspendOnCloseEnabled;
        window.hwaSuspendOnCloseState = shouldSuspendOnClose;
        window.hwaSuspendOnCloseAction = hwaSuspendOnCloseAction;
    }, [hwaSuspendOnCloseAction, shouldSuspendOnClose, suspendOnCloseEnabled]);
    var shouldRunAppInBackground = suspendOnCloseEnabled;
    var setShouldRunAppInBackground = function (value) {
        return setshouldSuspendOnClose(value);
    };
    return { shouldRunAppInBackground: shouldRunAppInBackground, setShouldRunAppInBackground: setShouldRunAppInBackground };
};
//# sourceMappingURL=useShouldRunAppInBackground.js.map